<template>
    <el-dialog class="dialog-body-wrap zimbra-dialog zimbra-limited-width-dialog zimbra-calendar-dialog-ct"
         :visible.sync="dialogEditFolderSearch" width="480px"
        :append-to-body="true" :close-on-click-modal="false" :show-close="false">
        <template slot="title">
            <div class="d-flex justify-content-between align-items-center">
                <div class="title-header-ct">{{$t('zimbra.zmMsg.folderProperties')}}</div>
                <div style="cursor: pointer" @click="handleClose" class="btn-css-ct">
                    <CloseIcon type="size20"/>
                </div>
            </div>
        </template>
        <el-form :model="formEdit" class="form-wrap" >
<!--            <el-form-item class="el-form-item-ct" :label="$t('zimbra.zhMsg.optionsAccountType')" label-width="110px">-->
<!--                <span>{{$t("zimbra.zmMsg.savedSearch")}}</span>-->
<!--            </el-form-item>-->
            <div class="d-flex flex-column" style="gap: 4px">
                <div class="text-type-ct">
                    {{$t('zimbra.zhMsg.optionsAccountType')}}
                </div>
                <div class="value-type-ct">
                    {{$t("zimbra.zmMsg.savedSearch")}}
                </div>
            </div>
            <el-form-item class="el-form-item-ct" :label="$t('zimbra.zhMsg.AB_FIELD_firstName')" label-width="110px">
                <div class="d-flex justify-content-between" style="gap: 16px">
                    <el-input class="el-text-control el-i-control-ct" v-model="formEdit.name" autocomplete="off" size="medium"></el-input>
                    <zm-color-picker class="zm-color-picker-ct" v-model="formEdit.rgb" :visible="false" :showFooter="true">
                    </zm-color-picker>
                </div>
            </el-form-item>
            <el-form-item class="el-form-item-ct" :label="$t('zimbra.zhMsg.search')" label-width="110px">
                <el-input class="el-text-control el-i-control-ct" v-model="formEdit.query" autocomplete="off" size="medium"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <div class="d-flex justify-content-end button-calendar" style="gap: 8px">
                <el-button class="btn-cancel" size="small" @click="dialogEditFolderSearch = false">{{
                        $t("zimbra.zhMsg.actionTaskCancelTT") }}</el-button>
            <el-button class="btn-calendar" size="small" type="primary" @click="editFolder()">{{
                    $t("zimbra.zmMsg.mobileStatusNeedProvision") }}</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import ZmColorPicker from "@/components/modules/base/base-color-picker-advance/zm-color-picker";
import CompileService from "@/services/CompileService.js";
import ZimbraMailService from "@/services/ZimbraMailService.js";
import CommonUtils from "@/utils/common-utils";
import EmailUltils from "@/utils/email-utils";
import CalendarUtils from "@/utils/calendar-utils";
import color from "./../listColor";
import _ from "lodash";
import { mapGetters } from "vuex";
import { STATUS_REQUEST } from "@/utils/constants";
import CloseIcon from "@/assets/icons/CloseIcon.vue";
import CalendarNumber from "@/assets/icons/CalendarNumber.vue";
export default {
    mixins: [CommonUtils, EmailUltils],
    mounted() {
        this.$root.$on("handleActionEditFolderSearch", () => {
            this.show();
        });
    },
    components: {
        CalendarNumber, CloseIcon,
        "zm-color-picker": ZmColorPicker,
    },
    data() {
        return {
            formEdit: {
                name: "",
                rgb: null,
            },
            listColor: color,
            dialogEditFolderSearch: false,
        };
    },
    computed: {
        ...mapGetters(["activeNodeSidebarRightClick"]),
    },
    methods: {
        show() {
            this.formEdit = _.cloneDeep(this.activeNodeSidebarRightClick);
            if (this.formEdit.color) {
                this.formEdit.rgb = this.listColor.find(
                    (x) => x.colorNumeric == this.formEdit.color
                ).value;
            }
            this.dialogEditFolderSearch = true;
        },
        handleClose() {
            this.dialogEditFolderSearch = false;
        },
        checkExistsName(name, folderParent) {
            if (Array.isArray(folderParent?.folder)) {
                if (folderParent.folder.map(x => x.name.toString().toLowerCase()).indexOf(name.toString().toLowerCase()) > -1) {
                    let msgerror = this.$t("zimbraNokey.zimbra_searchBox_duplidateName", { name });
                    this.$alert(
                        msgerror,
                        this.$t("zimbraNokey.zimbra_sidebar_criticalMsg"),
                        {
                            confirmButtonText: this.$t("zimbra.zmMsg.mobileStatusNeedProvision"),
                            type: "error",
                        }
                    );
                    return true;
                }
            }
        },
        async editFolder() {
            this.formEdit.name = this.formEdit.name.trim();
            const folderSearches = await this.getFolderSearchApi();
            const nodeCalContain = CalendarUtils.methods.searchNodeById({ id: 1, folder: folderSearches[0].search }, this.formEdit.l)
            if (
                this.formEdit.name == "" ||
                this.formEdit.name.length > 128 ||
                this.formEdit.name.indexOf("/") > -1 ||
                this.formEdit.name.indexOf(`"`) > -1 ||
                /[!@#$%^&*(),.?":{}|<>]/.test(this.formEdit.name)
            ) {
                const nameError = _.escape(this.formEdit.name);
                const Msgerror =
                    this.formEdit.name == ""
                        ? this.$t("zimbra.zmMsg.nameEmpty")
                        : this.formEdit.name.length > 128
                            ? this.$t("zimbra.zhMsg.nameTooLong", { 0: 128 })
                            : this.$t(
                                "zimbra.zmMsg.errorInvalidName",
                                { 0: this.formEdit.name }
                            );
                this.$alert(Msgerror, this.$t("zimbraNokey.zimbra_sidebar_criticalMsg"), {
                    confirmButtonText: this.$t("zimbra.zmMsg.mobileStatusNeedProvision"),
                    type: "error",
                });
                return;
            }
            if (this.formEdit.name.toLowerCase() != this.activeNodeSidebarRightClick.name.toString().toLowerCase()) { /// check trùng với tên viết hoa của chính nó
                if (this.checkExistsName(this.formEdit.name, nodeCalContain)) {
                    return;
                }
            }
            // this.formEdit.name = _.escape(this.formEdit.name);
            let stringXml = [];
            if (this.formEdit.name != this.activeNodeSidebarRightClick.name) {
                const xml = `<urn1:action id="${this.formEdit.id}" op="rename" name="${this.formEdit.name}"></urn1:action>`;
                stringXml.push({
                    path: "folderActionRequest",
                    content: { folder: xml },
                });
            }
            if (this.formEdit.rgb != this.activeNodeSidebarRightClick.rgb) {
                this.formEdit.rgb =
                    this.formEdit.rgb == null ? "" : this.formEdit.rgb;
                const xml = `<urn1:action id="${this.formEdit.id}" op="color" rgb="${this.formEdit.rgb}"></urn1:action>`;
                stringXml.push({
                    path: "folderActionRequest",
                    content: {folder: xml },
                });
            }
            const formData = {
                id: `${this.formEdit.id}`,
                query: _.escape(this.formEdit.query),
                types: this.formEdit.types,
            };

            ZimbraMailService.modifySearchFolderRequest(formData).then((request) => {
                if (request.status == STATUS_REQUEST.SUCCESS) {
                    const folder = this.activeNodeSidebarRightClick;
                    folder.name = this.formEdit.name;
                    folder.query = this.formEdit.query;
                    folder.rgb = this.formEdit.rgb;
                    const formData1 = {
                        listRequest: stringXml,
                    };
                    if (stringXml != "") {

                        // CompileService.batchRequest(formData1).then((res) => {
                        // if (res.data.code == "SUCCESS") {
                        //     this.$notify({
                        //         title: this.$t("zimbra.zmMsg.dataSourceTestSuccess"),
                        //         message: this.$t(
                        //             "zimbraNokey.zimbra_sidebar_dialogEditFolder_updateFolderSuccess"
                        //         ),
                        //         type: "success",
                        //     });
                        //     this.$store.commit("SET_ACTIVE_NODE_SIDEBAR", folder);
                        // }
                        let test = true;
                        stringXml.forEach((content) => {
                            ZimbraMailService.folderActionRequest(content.content).then((res) => {
                                if (res.status !== 200) {
                                    test = false
                                }
                            })
                        });
                        if (test) {
                            this.$notify({
                                title: this.$t("zimbra.zmMsg.dataSourceTestSuccess"),
                                message: this.$t(
                                    "zimbraNokey.zimbra_sidebar_dialogEditFolder_updateFolderSuccess"
                                ),
                                type: "success",
                            });
                            this.$store.commit("SET_ACTIVE_NODE_SIDEBAR", folder);
                        }

                    }
                }
            })
            this.dialogEditFolderSearch = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.el-form-item-ct {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    gap: 4px;
}
.el-form-item-ct  .el-form-item__content {
    width: 100% !important;
}
::v-deep {
    .el-text-control>input:focus {
        border-color: unset !important;
    }
    .form-wrap .el-form-item {
        margin: 0;
    }

    .zm-color-picker-ct .el-input__inner{
        padding: 0;
        height: 32px;
        border: none !important;
    }
    .compose-color .form-controls .input-control .el-input__inner {
        border: none !important;
    }
    .compose-color .one-colorpicker .color-block .color-block-layer {
        border-radius: 50%;
        width: 24px;
        height: 24px;
    }
    .compose-color .one-colorpicker .color-block {
        top: -2px;
        width: 24px;
        height: 24px;
    }
    .el-input__inner {
        width: 327px;
    }
    .el-form-item::before,
    .el-form-item::after{
        display: none !important;
    }
    .form-wrap .el-form-item__label {
        color: var(--Neutral-09, #313131);

        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
    }
}

.text-type-ct {
    color: var(--Neutral-07, #888);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
}
.value-type-ct {
    color: var(--Neutral-09, #313131);

    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
}
.text-label {
    color: var(--Neutral-09, #313131);

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
}
</style>
